var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player",class:{ loading: _vm.loading }},[_c('iframe',{ref:"player",attrs:{"frameborder":"0","allowfullscreen":"allowfullscreen","name":"webview_player"}}),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d605113","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/Player.vue
// module id = 977
// module chunks = 1